// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type ProcessingSessionId = ID<"processingSession">;
export const processingSessionIdFormat = idFormat<ProcessingSessionId>({
  prefix: "rps_",
});

export type ProcessingSessionItemId = ID<"processingSessionItem">;
export const processingSessionItemIdFormat = idFormat<ProcessingSessionItemId>({
  prefix: "rpsi_",
});

export type ExchangeAgentGuidanceId = ID<"exchangeAgentGuidance">;
export const exchangeAgentGuidanceIdFormat = idFormat<ExchangeAgentGuidanceId>({
  prefix: "eag_",
});

export type ReturnId = ID<"return">;
export const returnIdFormat = idFormat<ReturnId>({ prefix: "rtrn_" });

export type ReturnShipmentGroupId = ID<"returnShipmentGroup">;
export const returnShipmentGroupIdFormat = idFormat<ReturnShipmentGroupId>({
  prefix: "rsg_",
});

export type ReturnShipmentId = ID<"returnShipment">;
export const returnShipmentIdFormat = idFormat<ReturnShipmentId>({
  prefix: "rsh_",
});

export type ReturnItemId = ID<"returnItem">;
export const returnItemIdFormat = idFormat<ReturnItemId>({ prefix: "rit_" });

export type LaneId = ID<"lane">;
export const laneIdFormat = idFormat<LaneId>({ prefix: "ln_" });
